module.exports = __webpack_public_path__ + "img/stitlew.f59cfee5.png";